import { render } from "./settingModal.vue?vue&type=template&id=caba848e&scoped=true"
import script from "./settingModal.vue?vue&type=script&lang=js"
export * from "./settingModal.vue?vue&type=script&lang=js"

import "./settingModal.vue?vue&type=style&index=0&id=caba848e&lang=scss&scoped=true"

import exportComponent from "C:\\wamp64\\www\\DDP\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caba848e"]])

export default __exports__